import { DateTime } from 'luxon';

import { Cdek } from '@shared/assets';

import styles from './index.module.scss';
import { useWindowWidth } from '@shared/hooks';

const DeliveryCompany = ({ order }) => {
	const METHODS = {
		CDEK_METHOD: 'C',
		PICKUP: 'S',
	};

	const windowWidth = useWindowWidth();

	return (
		<div className={styles.delivery__container}>
			<div className={styles.delivery__company}>
				{order.carrier === METHODS.CDEK_METHOD ? (
					<Cdek />
				) : (
					<div className={styles.pickup}>Самовывоз</div>
				)}
			</div>
			{order.carrier === METHODS.CDEK_METHOD && order.delivery_metadata.date_delivery_max && (
				<div className={styles.delivery__date__wrapper}>
					<div className={styles.delivery__text}>Примерная дата доставки</div>
					<div className={styles.delivery__date}>
						{windowWidth > 600 && DateTime.fromISO(order.delivery_metadata.date_delivery_max).toLocaleString({
							day: 'numeric',
							month: 'long',
							year: 'numeric',
						})}

						{windowWidth <= 600 && DateTime.fromISO(order.delivery_metadata.date_delivery_max).toLocaleString({
							day: 'numeric',
							month: 'numeric',
							year: 'numeric',
						})}
					</div>
				</div>
			)}
		</div>
	);
};

export default DeliveryCompany;
